import getCharacter from "../../../utils/getCharacter";
import htmlDecode from "../../../utils/htmlDecode";
import CryptoJS from "crypto-js";
import BaseEndpoint from "../../../endpoints/baseEndpoint";
import useAuthUser from "../../../hooks/useAuthUser";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

const getStoredAnswer = () => {
    const raw = localStorage.getItem("answer");
    if (!raw) return null;
    try {
        const decrypted = CryptoJS.AES.decrypt(raw, "secret").toString(
            CryptoJS.enc.Utf8
        );
        return JSON.parse(decrypted);
    } catch (e) {
        return null;
    }
};

export default function Long({ session, current, countdown, nextSession }) {
    const router = useHistory();
    const { user } = useAuthUser();
    const [answerData, setAnswerData] = useState(() => getStoredAnswer());

    // Debug logging
    useEffect(() => {
        console.log('🔵 PT Potensi Kerja (Long) State:', {
            session: current.data.session,
            soal: current.data.soal,
            sessionType: session.data[current.data.session]?.type,
            sessionName: session.data[current.data.session]?.name,
            contentLength: session.data[current.data.session]?.content?.length,
            hasContent: !!session.data[current.data.session]?.content
        });
    }, [current.data.session, current.data.soal]);

    useEffect(() => {
        if (countdown.duration === 0) {
            if (current.data.session === null) return;
            if (session.data.length === 0) return;

            let next = nextSession();
            if (next) {
                // Read from localStorage directly to get all answers
                let finalAnswerStr = localStorage.getItem('answer');
                let finalAnswer = {};
                if (finalAnswerStr) {
                    try {
                        finalAnswerStr = CryptoJS.AES.decrypt(finalAnswerStr, 'secret').toString(CryptoJS.enc.Utf8);
                        finalAnswer = JSON.parse(finalAnswerStr);
                    } catch (error) {
                        console.error('❌ Error parsing localStorage answer:', error);
                        finalAnswer = {};
                    }
                }

                const params = new URLSearchParams(window.location.search);
                BaseEndpoint.instance()
                    .post(`/exam/${user.version}`, {
                        id: params.get("id"),
                        token: user.token,
                        type: session.data[current.data.session].name,
                        answer: finalAnswer,
                    })
                    .then((response) => {
                        if (response.status === 200) {
                            localStorage.removeItem("answer");
                            localStorage.removeItem("session");
                            setAnswerData(null);
                            router.push("/app/finish");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
    }, [countdown]);

    const getInstruction = () => {
        if (!session.data || session.data.length === 0) return "";
        if (current.data.session === null || current.data.soal === null) return "";
        if (
            ["break", "instruction"].includes(
                session.data[current.data.session]?.type
            )
        )
            return "";

        const currentContent = session.data[current.data.session]?.content;
        if (!currentContent || !currentContent[current.data.soal]) {
            console.error('❌ PT PK: No content at index', current.data.soal);
            return "";
        }

        const master = currentContent[current.data.soal]?.master;
        if (!master) {
            console.error('❌ PT PK: No master data');
            return "";
        }

        return [
            ...htmlDecode(master),
        ].map((item, index) => (
            <div key={index} className="col">
                <div
                    className={`text-center rounded-3 ${
                        index !== 4 ? "me-2" : ""
                    }`}
                    style={{ fontSize: "2rem", fontWeight: 700 }}
                >
                    <span className="mb-0" style={{ fontSize: "3rem" }}>
                        {item}
                    </span>
                    <div className="" style={{ opacity: 0.4 }}>
                        {getCharacter(index).toUpperCase()}
                    </div>
                </div>
            </div>
        ));
    };

    const getQuestion = () => {
        if (!session.data || session.data.length === 0) return "";
        if (current.data.session === null || current.data.soal === null) return "";
        if (
            ["break", "instruction"].includes(
                session.data[current.data.session]?.type
            )
        )
            return "";

        const currentContent = session.data[current.data.session]?.content;
        if (!currentContent || !currentContent[current.data.soal]) {
            console.error('❌ PT PK: No content at index', current.data.soal);
            return "";
        }

        const soal = currentContent[current.data.soal]?.soal;
        if (!soal) {
            console.error('❌ PT PK: No soal data');
            return "";
        }

        return [
            ...htmlDecode(soal),
        ].map((item, index) => (
            <div
                key={index}
                className="mb-0 mx-2 col px-4 border rounded-3 text-center"
                style={{ fontSize: "2.5rem" }}
            >
                {item}
            </div>
        ));
    };

    const getColumn = () => {
        if (!session.data || session.data.length === 0) return "";
        if (current.data.session === null || current.data.soal === null) return "";
        if (
            ["break", "instruction"].includes(
                session.data[current.data.session]?.type
            )
        )
            return "";

        const currentContent = session.data[current.data.session]?.content;
        if (!currentContent || !currentContent[current.data.soal]) {
            return "";
        }

        const kolom = currentContent[current.data.soal]?.kolom || '?';

        return (
            <h3
                className="mb-4 text-center"
                style={{ fontSize: "2rem", fontWeight: 700 }}
            >
                {"Kolom " + kolom}
            </h3>
        );
    };

    const answering = (id, jawaban) => {
        // Read from localStorage to get latest answers (not from state which may be stale)
        let answer = {};
        const storedAnswer = localStorage.getItem('answer');
        if (storedAnswer) {
            try {
                const decrypted = CryptoJS.AES.decrypt(storedAnswer, 'secret').toString(CryptoJS.enc.Utf8);
                answer = JSON.parse(decrypted);
            } catch (error) {
                console.error('❌ Error parsing stored answers:', error);
                answer = {};
            }
        }

        answer[id] = jawaban;
        console.log(`💾 Answer saved: Question ${id} = ${jawaban}`, {
            totalAnswers: Object.keys(answer).length,
            answers: answer
        });
        setAnswerData(answer);
        localStorage.setItem(
            "answer",
            CryptoJS.AES.encrypt(JSON.stringify(answer), "secret").toString()
        );
    };

    // Check if we have valid question data
    const hasValidData = session.data &&
                         session.data.length > 0 &&
                         current.data.session !== null &&
                         current.data.soal !== null &&
                         session.data[current.data.session]?.type === 'exam' &&
                         session.data[current.data.session]?.content &&
                         session.data[current.data.session].content[current.data.soal];

    if (!hasValidData) {
        return (
            <div className="mx-0 mt-4 px-0 col-md-12">
                <div className="card mb-3">
                    <div className="card-body">
                        <h5 className="card-title text-center">⏳ Loading Potensi Kerja...</h5>
                        <p className="text-center text-muted">
                            Session: {current.data.session}, Question: {current.data.soal}
                        </p>
                        <p className="text-center text-warning">
                            {!session.data && 'No session data'}
                            {session.data && current.data.session === null && 'Session is null'}
                            {session.data && current.data.soal === null && 'Soal index is null'}
                            {session.data && current.data.session !== null && session.data[current.data.session]?.type !== 'exam' && `Type is ${session.data[current.data.session]?.type}`}
                            {session.data && current.data.session !== null && !session.data[current.data.session]?.content && 'No content array'}
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="mx-0 mt-4 px-0 col-md-12">
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className="card-title border-bottom pb-3">Instruksi</h5>
                    <div
                        className="row py-3"
                        style={{ maxWidth: "550px", margin: "auto" }}
                    >
                        {getColumn()}
                        {getInstruction()}
                    </div>
                </div>
            </div>
            <div className="card mb-3">
                <div className="card-body">
                    <h5 className="card-title border-bottom pb-3">
                        Pertanyaan
                    </h5>
                    <div
                        className="row py-3"
                        style={{
                            fontSize: "5rem",
                            fontWeight: 700,
                            maxWidth: "700px",
                        }}
                    >
                        {getQuestion()}
                    </div>
                    {session.data &&
                        session.data.length > 0 &&
                        !["break", "instruction"].includes(
                            session.data[current.data.session].type
                        ) &&
                        session.data[current.data.session].content && (
                            <div className="row mt-3 px-3">
                                {Array.from(Array(5).keys()).map(
                                    (item, index) => (
                                        <input
                                            key={index}
                                            onClick={(e) => {
                                                answering(
                                                    session.data[
                                                        current.data.session
                                                    ].content[current.data.soal]
                                                        .id,
                                                    getCharacter(
                                                        index
                                                    ).toUpperCase()
                                                );

                                                if (
                                                    current.data.soal + 1 ===
                                                    session.data[
                                                        current.data.session
                                                    ].content.length
                                                ) {
                                                    console.log('✅ Last question in session, calling nextSession()');
                                                    let next = nextSession();
                                                    console.log('➡️ nextSession returned:', next);

                                                    if (next) {
                                                        // Read from localStorage directly to get all answers including the one we just saved
                                                        let finalAnswerStr = localStorage.getItem('answer');
                                                        let finalAnswer = {};
                                                        if (finalAnswerStr) {
                                                            try {
                                                                finalAnswerStr = CryptoJS.AES.decrypt(finalAnswerStr, 'secret').toString(CryptoJS.enc.Utf8);
                                                                finalAnswer = JSON.parse(finalAnswerStr);
                                                            } catch (error) {
                                                                console.error('❌ Error parsing localStorage answer:', error);
                                                                finalAnswer = {};
                                                            }
                                                        }

                                                        console.log('🏁 All sessions complete, saving exam...', {
                                                            totalAnswers: Object.keys(finalAnswer).length,
                                                            answers: finalAnswer
                                                        });

                                                        const params =
                                                            new URLSearchParams(
                                                                window.location.search
                                                            );
                                                        BaseEndpoint.instance()
                                                            .post(
                                                                `/exam/${user.version}`,
                                                                {
                                                                    id: params.get(
                                                                        "id"
                                                                    ),
                                                                    token: user.token,
                                                                    type: session
                                                                        .data[
                                                                        current
                                                                            .data
                                                                            .session
                                                                    ].name,
                                                                    answer: finalAnswer,
                                                                }
                                                            )
                                                            .then(
                                                                (response) => {
                                                                    console.log('✅ Save response:', response);
                                                                    if (
                                                                        response.status ===
                                                                        200
                                                                    ) {
                                                                        localStorage.removeItem(
                                                                            "answer"
                                                                        );
                                                                        localStorage.removeItem(
                                                                            "session"
                                                                        );
                                                                        setAnswerData(
                                                                            null
                                                                        );
                                                                        router.push(
                                                                            "/app/finish"
                                                                        );
                                                                    }
                                                                }
                                                            )
                                                            .catch((error) => {
                                                                console.error('❌ Save error:', error);
                                                            });
                                                    }
                                                } else {
                                                    current.set({
                                                        ...current.data,
                                                        soal:
                                                            current.data.soal +
                                                            1,
                                                    });
                                                }
                                            }}
                                            type="button"
                                            className={`col btn btn-primary btn-lg text-primary rounded-3 ${
                                                index !== 0 ? "ms-3" : ""
                                            }`}
                                            value={getCharacter(
                                                index
                                            ).toUpperCase()}
                                            style={{
                                                fontSize: "2rem",
                                                fontWeight: 700,
                                                borderStyle: "dashed",
                                                borderColor: "#f56409",
                                                backgroundColor: "#f564094d",
                                                borderWidth: "2px",
                                            }}
                                        />
                                    )
                                )}
                            </div>
                        )}
                </div>
            </div>
        </div>
    );
}
